import { render, staticRenderFns } from "./Compliance.vue?vue&type=template&id=4b1f5046&scoped=true&"
import script from "./Compliance.vue?vue&type=script&lang=js&"
export * from "./Compliance.vue?vue&type=script&lang=js&"
import style0 from "./Compliance.vue?vue&type=style&index=0&id=4b1f5046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f5046",
  null
  
)

export default component.exports